import styled from 'styled-components';
import theme from '../../../styles/theme';

export const Container = styled.div`
  margin: 0 auto;
  max-width: 1038px;
  width: 100%;
  margin-top: 3%;
`;

export const CardPersonalInformation = styled.div`
  background-color: #fff;
  width: '100%';
  padding: 10px;
  border-bottom: 1px solid ${theme.greenDefault};
`;

export const HoverActions = styled.div`
  padding: 5px;
  margin-right: 10px;
  &:hover {
    background-color: ${theme.greenDefault};
    border-radius: 5px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    word-break: normal;

    svg {
      color: #fff !important;

      /*  path {
        fill: #fff !important;
      } */
    }
  }
`;
